module.exports = __webpack_public_path__ + "img/image34.9524d025.png";